var _rect, _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVk(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 14,
    width: 100,
    height: 100,
    rx: 30,
    fill: "#808080"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_828_611",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 19,
    y: 19,
    width: 90,
    height: 90
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M108.531 19.4688H19.4688V108.531H108.531V19.4688Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_828_611)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64 108.531C88.5939 108.531 108.531 88.5939 108.531 64C108.531 39.4061 88.5939 19.4688 64 19.4688C39.4061 19.4688 19.4688 39.4061 19.4688 64C19.4688 88.5939 39.4061 108.531 64 108.531Z",
    fill: "#278BF1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.2555 87.8782H67.4132C67.4132 87.8782 68.67 87.7391 69.3095 87.0475C69.9009 86.4125 69.8792 85.221 69.8792 85.221C69.8792 85.221 69.7965 79.641 72.3886 78.8191C74.9415 78.0102 78.2206 84.2119 81.6956 86.5995C84.3224 88.4044 86.3187 88.0087 86.3187 88.0087L95.6127 87.8782C95.6127 87.8782 100.475 87.5782 98.1699 83.7553C97.9829 83.4422 96.826 80.9284 91.2592 75.7617C85.4314 70.3514 86.2143 71.23 93.2337 61.8751C97.5087 56.1777 99.218 52.6985 98.6831 51.2111C98.1743 49.7934 95.0298 50.1674 95.0298 50.1674L84.5746 50.2283C84.5746 50.2283 83.8006 50.1239 83.222 50.4675C82.661 50.8067 82.3001 51.5894 82.3001 51.5894C82.3001 51.5894 80.643 55.9994 78.4337 59.7484C73.7758 67.6593 71.9102 68.0768 71.149 67.5854C69.3791 66.4417 69.8226 62.984 69.8226 60.5312C69.8226 52.8638 70.9837 49.6673 67.5568 48.8409C66.4172 48.5669 65.5822 48.3842 62.6728 48.3538C58.9412 48.3147 55.7795 48.3668 53.9919 49.2409C52.8004 49.8238 51.8826 51.1241 52.4436 51.1981C53.1352 51.2894 54.7008 51.6199 55.5316 52.7507C56.6057 54.2077 56.5666 57.4869 56.5666 57.4869C56.5666 57.4869 57.1841 66.5112 55.1271 67.6332C53.7136 68.4031 51.7783 66.833 47.6248 59.6527C45.4981 55.9777 43.8891 51.9114 43.8891 51.9114C43.8891 51.9114 43.5803 51.1546 43.0279 50.7501C42.3582 50.2587 41.4188 50.1022 41.4188 50.1022L31.4768 50.163C31.4768 50.163 29.9851 50.2065 29.4371 50.8545C28.95 51.4329 29.3979 52.6246 29.3979 52.6246C29.3979 52.6246 37.1828 70.8342 45.9941 80.015C54.0789 88.4305 63.2555 87.8782 63.2555 87.8782Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVk);
export default __webpack_public_path__ + "static/media/VK.c0589b18a989c35e4600ce71b9760e81.svg";
export { ForwardRef as ReactComponent };